import type { BackNavConfig } from '../../hooks/use-back-navigation';
import { isValidTripRequestIdForPath } from '../../utils/trip-requests';

/**
 * Config for trip match review area: always back to the trip match page.
 * Falls back to My Trips → / if tripMatchId is missing.
 */
export function getTripMatchReviewBackNavConfig(
  _pathname: string,
  params: Record<string, string | undefined>,
): BackNavConfig {
  const { tripMatchId } = params;
  if (tripMatchId) {
    return { primaryText: 'Trip Match', targetPath: `/trip-matches/${tripMatchId}` };
  }
  return { primaryText: 'My Trips', targetPath: '/' };
}

/**
 * Config for account area: edit-profile/security -> My Profile → /account, else My Trips → /
 */
export function getAccountBackNavConfig(
  pathname: string,
): BackNavConfig {
  const isAccountSubPage = pathname.includes('/edit-profile') || pathname.includes('/security');
  return {
    primaryText: isAccountSubPage ? 'My Profile' : 'My Trips',
    targetPath: isAccountSubPage ? '/account' : '/',
  };
}

/**
 * Config for home: always My Trips → /
 */
export function getHomeBackNavConfig(): BackNavConfig {
  return { primaryText: 'My Trips', targetPath: '/' };
}

/**
 * Config for trip request area: on cancel page with valid id → Trip Request → details; else My Trips → /
 */
export function getTripRequestBackNavConfig(
  pathname: string,
  params: Record<string, string | undefined>,
): BackNavConfig {
  const { tripRequestId } = params;
  const isCancel = pathname.includes('/cancel');
  const safeTargetPath = isCancel && isValidTripRequestIdForPath(tripRequestId)
    ? `/trip-requests/${tripRequestId}`
    : '/';
  return {
    primaryText: isCancel ? 'Trip Request' : 'My Trips',
    targetPath: safeTargetPath,
  };
}
